import axios from "axios";
import { AUTH_LOGIN, AUTH_REGISTER, API_TIMEOUT } from "../utils";
import { getDashboardPath } from "../services/api";
import { expandAllowedRoles } from "../utils/roles";

export const LANDING_PATH = "/";

const redirectToHashPath = (path) => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  window.location.replace(`${window.location.origin}${window.location.pathname}#${normalized}`);
};

export const loginUser = async (username, password, setLoginProses, navigate) => {
  try {
    const response = await axios.post(
      AUTH_LOGIN,
      { username, password },
      { timeout: API_TIMEOUT }
    );

    if (!response.data?.success) {
      alert(response.data?.message || "Login gagal");
      setLoginProses(false);
      return;
    }

    const { token, user } = response.data.data;
    if (!user?.role) {
      alert("Login gagal: data role pengguna tidak ditemukan");
      setLoginProses(false);
      return;
    }

    localStorage.setItem(
      "user",
      JSON.stringify({
        ...user,
        token,
      })
    );

    const dashboardPath = getDashboardPath(user.role);
    if (navigate) {
      navigate(dashboardPath, { replace: true });
      setLoginProses(false);
      return;
    }

    redirectToHashPath(dashboardPath);
  } catch (error) {
    const message =
      error.response?.data?.message ||
      "Gagal terhubung ke server TIALAI. Pastikan backend berjalan.";
    alert(message);
    setLoginProses(false);
  }
};

export const registerUser = async (formData, setLoading, navigate) => {
  try {
    const response = await axios.post(AUTH_REGISTER, formData, {
      timeout: API_TIMEOUT,
    });

    if (!response.data?.success) {
      alert(response.data?.message || "Registrasi gagal");
      setLoading(false);
      return;
    }

    alert("Registrasi berhasil. Silakan login.");
    navigate("/authentication/sign-in/cover");
    setLoading(false);
  } catch (error) {
    alert(error.response?.data?.message || "Registrasi gagal");
    setLoading(false);
  }
};

export function logoutUser(navigate) {
  localStorage.removeItem("user");
  if (navigate) {
    navigate(LANDING_PATH, { replace: true });
    return;
  }
  redirectToHashPath(LANDING_PATH);
}

export const getCurrentUser = () => {
  const raw = localStorage.getItem("user");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const requireAuth = (navigate, allowedRoles = null) => {
  const user = getCurrentUser();
  if (!user?.token) {
    logoutUser(navigate);
    return null;
  }
  if (allowedRoles) {
    const expanded = expandAllowedRoles(allowedRoles);
    if (!expanded.includes(user.role)) {
      navigate(getDashboardPath(user.role));
      return null;
    }
  }
  return user;
};
